import { createBrowserRouter } from "react-router";
import { ProtectedRoute } from "~/components/ProtectedRoute";
import { RouteTracker } from "~/components/RouteTracker";

// Pages
import Home from "~/pages/Home";
import Login from "~/pages/Login";
import GoogleAuth from "~/pages/login/GoogleAuth";
import MicrosoftAuth from "~/pages/login/MicrosoftAuth";
import Logout from "~/pages/Logout";
import SessionLayout from "~/pages/session/SessionLayout";
import SessionContainer from "~/components/session-container/session-container";
import VibeSession from "~/pages/session/vibe/VibeSession";
import TechnicalSession from "~/pages/session/technical/TechnicalSession";
import OrderDetails from "~/components/price-comparison/order-details";
import PaymentStatus from "~/components/price-comparison/payment-status";

// Database Connection Pages
import Connections from "~/pages/connections/connections";
import PostgreSQLConnection from "~/pages/connections/new/postgresql";
import MySQLConnection from "~/pages/connections/new/mysql";
import SnowflakeConnection from "~/pages/connections/new/snowflake";
import ShopifyConnection from "~/pages/connections/new/shopify";
import MetabaseConnection from "~/pages/connections/new/metabase";
import InstagramConnection from "~/pages/connections/new/instagram";
import EditConnection from "~/pages/connections/edit-connection";

export const router = createBrowserRouter([
  {
    element: <RouteTracker />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/login/authenticate/google",
        element: <GoogleAuth />,
      },
      {
        path: "/login/authenticate/microsoft",
        element: <MicrosoftAuth />,
      },
      {
        path: "/logout",
        element: <Logout />,
      },
      {
        path: "/billing",
        element: <OrderDetails />,
      },
      {
        path: "/payment-status",
        element: <PaymentStatus />,
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <SessionLayout />,
            children: [
              {
                path: "/session",
                element: <SessionContainer />,
              },
              {
                path: "/session/vibe/:sessionId",
                element: <VibeSession />,
              },
              {
                path: "/session/technical/:sessionId",
                element: <TechnicalSession />,
              },
              {
                path: "/connections",
                element: <Connections />,
              },
              {
                path: "/connections/new/postgresql",
                element: <PostgreSQLConnection />,
              },
              {
                path: "/connections/new/mysql",
                element: <MySQLConnection />,
              },
              {
                path: "/connections/new/snowflake",
                element: <SnowflakeConnection />,
              },
              {
                path: "/connections/new/shopify",
                element: <ShopifyConnection />,
              },
              {
                path: "/connections/new/metabase",
                element: <MetabaseConnection />,
              },
              {
                path: "/connections/new/instagram",
                element: <InstagramConnection />,
              },
              {
                path: "/connections/:id/edit",
                element: <EditConnection />,
              },
            ],
          },
        ],
      },
    ],
  },
]);
